import React from 'react';

function NoticeModal({ onClick }) {
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 'auto',
        color: '#fff',
        backgroundColor: '#90103B',
        zIndex: 10000,
        cursor: 'pointer',
        borderStyle: 'solid',
        borderWidth: 1,
        borderRadius: 10,
      }}
      onClick={onClick}
    >
      <p style={{ padding: 3 }}>
        Live stream is in mute. Please unmute for sound.
      </p>
    </div>
  );
}

export default NoticeModal;
